export class DepoolingRetestDTO{
    _id:string;
    output :DepoolingRetestData;
    }

export class Falcon{
        falconID: string;
        bagID : string;
        classID: string;
        schoolID: string;
        unboxed: string;
        sender: string;
        resultReceivedDate: Date;
        retestListColor: string;
        boxID: string;
        lastModifiedBy: string;
        lastModifiedDate: any;
    }

    export class DepoolingRetestData{
        boxID:string;
        storageID:string;
        parentRowPosition:string;
        falcons:Falcon;
        }

export class DepoolingRetestResponseDTO{
        paginatedResults:DepoolingRetestDTO[];
        totalCount:any;
      }